module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "message"
  }, [_c('latestnews'), _vm._v(" "), _c('div', {
    staticClass: "con"
  }, [_c('top', {
    attrs: {
      "title": '消息大厅'
    }
  }, [_c('div', [_c('a', {
    staticClass: "buy-btn",
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.toNewPage('/goods')
      }
    }
  }, [_vm._v("我要买")]), _vm._v(" "), (_vm.userInfo) ? _c('a', {
    staticClass: "sell-btn",
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.toNewPage('/sold-acc')
      }
    }
  }, [_vm._v("我要卖")]) : _c('a', {
    staticClass: "sell-btn",
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": _vm.showLogin
    }
  }, [_vm._v("我要卖")])])]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_vm._m(0), _vm._v(" "), _vm._l((_vm.mesList), function(item) {
    return _c('tr', {
      key: item.id,
      class: {
        unread: item.status == 0
      }
    }, [_c('td', {
      staticStyle: {
        "width": "210px"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticClass: "content"
    }, [_c('span', [_vm._v(_vm._s(item.message))])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "224px"
      }
    }, [_vm._v(_vm._s(_vm._f("formatDate")(item.created_at * 1000)))]), _vm._v(" "), _c('td', {
      staticClass: "detail",
      staticStyle: {
        "width": "80px"
      },
      on: {
        "click": function($event) {
          _vm.turnDetail(item)
        }
      }
    }, [_vm._v("查看详情")])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "p-l"
  }, [_c('p', {
    staticClass: "total"
  }, [_vm._v("共" + _vm._s(_vm.page.total_count) + "条记录," + _vm._s(_vm.page.total_page) + "页,每页" + _vm._s(_vm.page.page_size) + "条记录")]), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.page.page_current,
      "page-size": _vm.page.page_size,
      "layout": "prev, pager, next",
      "total": _vm.page.total_count,
      "prev-text": "上一页",
      "next-text": "下一页"
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.page.page_current,
      "page-size": _vm.page.page_size,
      "layout": "slot",
      "total": _vm.page.total_count
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }, [_c('ul', {
    staticClass: "jumper"
  }, [_c('li', [_vm._v("每页显示:")]), _vm._v(" "), _vm._l((_vm.sizes), function(item) {
    return _c('li', {
      key: item.id,
      on: {
        "click": function($event) {
          _vm.handleSizeChange(item)
        }
      }
    }, [_vm._v(_vm._s(item))])
  })], 2)])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "收件详情",
      "visible": _vm.sjFormVisible,
      "custom-class": "dialog-t",
      "width": "1011px"
    },
    on: {
      "update:visible": function($event) {
        _vm.sjFormVisible = $event
      }
    }
  }, [_c('item', {
    attrs: {
      "data": _vm.select
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.sjFormVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("标题 ")]), _vm._v(" "), _c('th', [_vm._v("内容 ")]), _vm._v(" "), _c('th', [_vm._v("时间 ")]), _vm._v(" "), _c('th', [_vm._v("操作")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee09e5d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/message/message.vue
// module id = 648
// module chunks = 31